export default "__VITE_ASSET__BDEUMDQc__"